import React, { useContext, useEffect, useState } from 'react'
import Editor from "../Editor.js";
import { Modal, ProgressBar } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { useHistory, useLocation, useParams } from 'react-router';
import { callApi } from '../../api/useApi';
import { ColorContext } from '../../AppContext';
import { uploadFileToStorage } from '../../services/firebaseServices';
import hexToRGB from '../../utils/HexToRGB';
import './Visibility.css'

const Visiblity = ({ display, onHide, path, files, onAdd, file, letterId, onEdit }) => {

    const [color,] = useContext(ColorContext);
    const [completed, setCompleted] = useState(0)
    const [uploading, setUploading] = useState(false)
    const [visible, setVisible] = useState("private")
    const [fileName, setFileName] = useState(file?.file ?? files[0].name);
    const [note, setNote] = useState(file?.note ?? "");

    const onExit = () => {
        onHide()
    };

    const onClick = (val) => {
        setVisible(val);
    }

    useEffect(() => {
        if (file !== undefined) {
            setVisible(file.visible)
        }
    }, [])

    const onSave = async () => {
        if (file !== undefined) {
            file.file = fileName;
            file.note = note;
            onEdit({ ...file, ...{ visible: visible } });
            onExit();
        } else {
            if (letterId) {
                setUploading(true)
                uploadFileToStorage(
                    path, files, (val) => console.log(val), (downloadUrl, uuid, file) => {
                        callApi("createFile", {
                            id: letterId,
                            params: {
                                visible: visible, downloadUrl: downloadUrl, uuid: uuid, file: fileName, note: note, type: file.type
                            }
                        }).then(val => {
                            let url = { visible: visible, downloadUrl: downloadUrl, uuid: uuid, id: val.records[0].get("id"), type: file.type, file: fileName, note: note };
                            onAdd(url);
                            setCompleted(val => val + 1)
                        }
                        )
                    },
                    () => {
                        setUploading(false)
                        onExit()
                    }
                )
            } else {
                setUploading(true)
                for (let index = 0; index < files.length; index++) {
                    const file = files[index];
                    let url = { visible: visible, downloadUrl: '', uuid: '', id: '', type: file.type, file: fileName, buffer: file };
                    onAdd(url);
                    setCompleted(val => val + 1)
                }
                setUploading(false)
                onExit()
            }
        }
    }

    return (

        <>

            <Modal show={display} size="md" onHide={onExit} onExit={onExit} onEscapeKeyDown={onExit} centered>
                <Modal.Body style={{ paddingTop: "20px", borderRadius: "10px" }}>
                    <fieldset>
                        <legend>File Name</legend>
                        <input
                            type="text"
                            value={fileName}
                            className="field-modal"
                            onChange={(e) => {
                                setFileName(e.target.value);
                            }}
                        />
                    </fieldset>
                    <fieldset>
                        <legend>Note</legend>
                        <textarea
                            type="text"
                            className="field-modal"
                            value={note}
                            rows="4"
                            cols="30"
                            onChange={(e) => {
                                setNote(e.target.value);
                            }}
                        />
                    </fieldset>
                    <button className="visibility-button visibility-button-special" style={visible === "private" ? { borderColor: `${color}`, background: hexToRGB(color, 0.08) } : {}} onClick={e => onClick("private")}>
                        <p style={visible === "private" ? { color: `${color}` } : {}} className="header-text-special">Private Upload</p>
                    </button>
                    <button className="visibility-button visibility-button-special" style={visible === "public" ? { borderColor: `${color}`, background: hexToRGB(color, 0.08) } : {}} onClick={e => onClick("public")}>
                        <p style={visible === "public" ? { color: `${color}` } : {}} className="header-text-special">Public Upload</p>
                    </button>
                    <div className="footer-style footer-style-special">
                        <button className={`footer-button ${isMobile ? "mobile" : ""}`} style={{ background: "transparent", borderColor: "#95989A", color: "#959595" }} onClick={onExit}>Cancel</button>
                        <button className={`footer-button ${isMobile ? "mobile" : ""}`} style={{ background: `${color}`, color: "#fff" }} onClick={onSave}>Upload</button>
                    </div>
                </Modal.Body>
            </Modal>
            {uploading && <Modal show={uploading} centered size="sm">
                <Modal.Body >
                    <ProgressBar animated now={completed} max={files.length} />
                    <p style={{ fontSize: "20px", textAlign: "center" }}>{`Uploading ${completed} out of ${files.length}`}</p>
                </Modal.Body>
            </Modal>}
        </>
    )
}

export default Visiblity